export class Refresh {
  private static refreshHandler: () => void
  private static clearCredentialsHandler: (
    needRefresh?: boolean
  ) => Promise<void>

  public static init(
    onRefresh: () => void,
    clearCredentials: (needRefresh?: boolean) => Promise<void>
  ): void {
    Refresh.refreshHandler = onRefresh
    Refresh.clearCredentialsHandler = clearCredentials
  }

  public static refresh(): void {
    Refresh.refreshHandler()
  }

  public static async clearCredentials(needRefresh?: boolean): Promise<void> {
    return Refresh.clearCredentialsHandler(needRefresh)
  }
}
